<template>
    <v-dialog v-model="$parent.showProcedureStagesModal" max-width="1000">
        <v-card class="pa-4">
            <v-card-title class="headline text-family text-pantone">Etapas</v-card-title>
            <v-divider class="mb-2 "></v-divider>
            <v-simple-table>
                <thead>
                <tr>
                    <!-- <th class="">No.</th> -->
                    <th class="">Etapa</th>
                    <th class="">Estado</th>
                    <th class="">Fecha de inicio</th>
                    <th class="">Última actualización</th>
                    <th class="">Fecha de Término</th>
                    <th class="">Fecha Vencimiento</th>
                    <th class="">Días restantes</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(stage) in $parent.procedureStages" :key="stage.id">
                    <!-- <td>{{$parent.procedureStages.length - index}}</td> -->
                    <td>{{stage.task.name}}</td>
                    <td>{{stage.status.male_label}}</td>
                    <td>{{stage.created_at}}</td>
                    <td>{{stage.updated_at}}</td>
                    <td>{{stage.ended_at}}</td>
                    <td>-</td>
                    <td>-</td>
                </tr>
                </tbody>
            </v-simple-table>

        </v-card>
    </v-dialog>
</template>

<script>
export default {
    data() {
        return{
        }
    },
}
</script>

<style scoped>
  .theme--light.v-divider {
        border-color: #ff840059;
        height: 3px !important;
        border-width: thin 0px  1px  0px;
    }
    .text-family{
        font-family: 'PoppinsRegular' !important;
    }
    .text-pantone{
        color: #ff8400 !important;
    }
    tr th {
        font-family: 'PoppinsRegular' !important;
    }
    tr td{
        font-family: 'PoppinsRegular' !important;
    }
</style>
